// ── Journey Config Summary ────────────────────────────────────────────────────
//
// Confirms, right in Account Setup, what's actually been saved for this
// customer so far — one line per stage, so a rep can see at a glance whether
// e.g. KYC + Cascade config was persisted without having to open that stage.
import { CheckCircle2, Circle } from 'lucide-react'
import type { PlatformJourneyRecord } from '@api/client'

const STAGE_SUMMARY_ITEMS: { key: keyof PlatformJourneyRecord; label: string }[] = [
  { key: 'workflowConfig', label: 'Workflow Builder' },
  { key: 'idvConfig', label: 'IDV & Biometrics' },
  { key: 'kycConfig', label: 'KYC + Cascade' },
  { key: 'kybConfig', label: 'KYB' },
  { key: 'amlConfig', label: 'AML' },
  { key: 'fraudConfig', label: 'Fraud' },
  { key: 'tmConfig', label: 'Transaction Monitoring' },
]

export function JourneyConfigSummary({ record }: { record: PlatformJourneyRecord | null }) {
  if (!record) return null
  return (
    <div className="rounded-[10px] p-3 space-y-2" style={{ background: '#f8fafc', border: '1px solid #e5e7eb' }}>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <p className="text-[9px] font-semibold uppercase tracking-wider text-[#64748b]">Saved configuration</p>
        <span className="text-[9px] text-[#94a3b8]">Last saved {new Date(record.updatedAt).toLocaleString()}</span>
      </div>
      <div className="grid grid-cols-2 gap-x-3 gap-y-1.5">
        {STAGE_SUMMARY_ITEMS.map(({ key, label }) => {
          const done = record[key] != null
          return (
            <div key={key} className="flex items-center gap-1.5 text-[11px]">
              {done
                ? <CheckCircle2 size={12} className="text-emerald-600 shrink-0" />
                : <Circle size={12} className="text-[#cbd5e1] shrink-0" />}
              <span style={{ color: done ? '#1e293b' : '#94a3b8' }}>{label}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
